import React, { useState } from 'react';

import { colorsSelector } from '@redux/colorPalette/selectors';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { sendMultiScreenEventToIpad } from 'services/helpers/multiScreen';
import { PlayerEvent } from 'shared-types/player-event';
import {
  windowPlacementApiBody,
  windowPlacementApiWindow,
  WindowPlacementScreens,
} from 'shared-types/windowPlacementAPICustomTypes';

import {
  DesktopPlayerContentWrapper,
  LauncherLogo,
  PlayerLauncherButton,
} from './DesktopPlayer.style';
import Player from './Player';

enum PLAYERMODES {
  LAUNCHER = 'LAUNCHER',
  TV = 'TV',
}

const PlayerLauncher: React.FC<{ launchPlayer: () => void }> = ({ launchPlayer }) => {
  const colors = useSelector(colorsSelector);
  return (
    <DesktopPlayerContentWrapper>
      <LauncherLogo />
      <PlayerLauncherButton onClick={launchPlayer} {...{ colors }}>
        <FormattedMessage id='desktop-player.launch' />
      </PlayerLauncherButton>
    </DesktopPlayerContentWrapper>
  );
};

export const DesktopPlayer: React.FC = () => {
  const [playerMode, setPlayerMode] = useState(PLAYERMODES.LAUNCHER);
  const findNonPrimaryScreen = (screens: WindowPlacementScreens) => {
    for (let i = 0; i < screens.length; i++) {
      const screen = screens[i];
      if (screen.isPrimary === false) {
        return screen;
      }
    }
    return null;
  };

  const launchPlayer = async () => {
    if (!windowPlacementApiWindow?.getScreenDetails) {
      return;
    }
    const screenDetails = await windowPlacementApiWindow.getScreenDetails();
    const nonPrimaryScreen = findNonPrimaryScreen(screenDetails.screens);

    if (!nonPrimaryScreen) {
      return;
    }
    windowPlacementApiBody.requestFullscreen({ screen: nonPrimaryScreen });
    sendMultiScreenEventToIpad(PlayerEvent.LAUNCH_AUTO_SCREEN_SPLIT_MODE);
    setPlayerMode(PLAYERMODES.TV);
  };

  return playerMode === PLAYERMODES.LAUNCHER ? (
    <PlayerLauncher launchPlayer={launchPlayer} />
  ) : (
    <Player />
  );
};
